module.exports = __webpack_public_path__ + "img/engage-fig-2.a563e83c.png";